import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import { useModuleData } from "../../hooks/useModuleData";
import { useUserProgress } from "../../hooks/useUserProgress";

import ForestBackdrop from "../ForestBackdrop/ForestBackdrop";
import { ModuleCard } from "./ModuleCard";
import styles from "./ModuleMenu.module.css";
import { LoadingTile } from "../../../../components/ui/Loading/LoadingTile";
import { useLoadingContent } from "../../../../hooks/useLoadingContent";
import { usePersistentLoading } from "../../../../hooks/usePersistentLoading";
import SEO from "../../../../components/seo/SEO";

export default function ModuleMenu() {
  const { modules, isLoading: isModulesLoading } = useModuleData();
  const { progressData, isLoading: isProgressLoading } = useUserProgress();
  const loadingContent = useLoadingContent();
  const { isShowing, tileProps } = usePersistentLoading(
    isModulesLoading || isProgressLoading,
    loadingContent
  );

  if (isShowing) {
    return <LoadingTile content={loadingContent} {...tileProps} />;
  }

  return (
    <>
      <SEO
        title="Art of Looking Module Menu"
        description="Pick up from where you left off or start your Art of Looking adventure from the start."
        canonicalUrl={"https://nowasteddays.io/art-of-looking-menu/"}
      />
      <ForestBackdrop>
        <main className={styles.pageContainer}>
          <header className={styles.intro}>
            <h1 className={styles.pageTitle}>
              Choose your next chapter
            </h1>
            <p className={styles.pageLede}>
              Pick up where you left off or begin a new module. Each one is a
              short, immersive read.
            </p>
          </header>
          <motion.div
            className={styles.menuGrid}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {modules &&
              modules
                .sort((a, b) => a.order - b.order)
                .map((module) => {
                  const moduleProgress = progressData?.moduleProgress?.find(
                    (p) => p.moduleId === module._id,
                  );
                  return (
                    <ModuleCard
                      key={module._id}
                      module={module}
                      progress={moduleProgress}
                    />
                  );
                })}

            {progressData?.finalQuizUnlocked && (
              <Link
                to={`/art-of-looking/final-quiz`}
                className={styles.quiz_tile}
              >
                <div className={styles.tileKicker}>
                  <span>Course test</span>
                </div>
                <h3 className={styles.cardHeader}>Final Quiz</h3>
                <p className={styles.cardDescription}>
                  You've completed all the modules. Put it all together.
                </p>
              </Link>
            )}
          </motion.div>
        </main>
      </ForestBackdrop>
    </>
  );
}
